





















import Vue from "vue";
import { mapGetters } from "vuex";
export default Vue.extend({
  name: "Facet",
  data(): {
    categories: string[];
    categoriesSelected: string[];
  } {
    return {
      categories: [],
      categoriesSelected: [],
    };
  },
  computed: {
    ...mapGetters(["getApps", "getFacets"]),
  },
  methods: {
    async selectCategory(categorySelected: string) {
      const isIncluded = await this.$store.dispatch(
        "searchIfFacetIsSelected",
        categorySelected.split(" (")[0]
      );
      if (!isIncluded) {
        this.$emit("selectCategory", categorySelected);
      }
    },
  },
});
